import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-condition-utilisation',
    templateUrl: './condition-utilisation.component.html',
    styleUrls: ['./condition-utilisation.component.css'],
    standalone: false
})
export class ConditionUtilisationComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
